import _createClass from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AmplifyErrorCode } from '../types/errors.mjs';
import { AmplifyError } from './AmplifyError.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var PlatformNotSupportedError = /*#__PURE__*/function (_AmplifyError) {
  _inherits(PlatformNotSupportedError, _AmplifyError);

  var _super = _createSuper(PlatformNotSupportedError);

  function PlatformNotSupportedError() {
    _classCallCheck(this, PlatformNotSupportedError);

    return _super.call(this, {
      name: AmplifyErrorCode.PlatformNotSupported,
      message: 'Function not supported on current platform'
    });
  }

  return _createClass(PlatformNotSupportedError);
}(AmplifyError);

export { PlatformNotSupportedError };